import { render, staticRenderFns } from "./receiveLogTable.vue?vue&type=template&id=4c0dd364"
import script from "./receiveLogTable.vue?vue&type=script&lang=js"
export * from "./receiveLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports